import React from "react"
import styled from "styled-components"
import Text from "@/components/common/Text"
import { useRouter } from "next/router"

export const Tag = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: start;
	padding: 13px 20px;
	cursor: pointer;
	border-radius: 8px;

	backdrop-filter: blur(8px);

	&:before {
		content: "";
		position: absolute;
		inset: 0;
		outline: solid 1px ${({ theme }) => theme.colors.white};
		border-radius: inherit;
		background-color: ${({ theme }) => theme.colors.richBlue};
		opacity: 0.75;
	}
`
const PreviewTag = () => {
	const router = useRouter()
	const handleClose = () => {
		router.push("/api/preview/exit")
	}
	return (
		<Tag onClick={handleClose}>
			<Text color="white">Jesteś w trybie preview</Text>
			<Text color="white">Kliknij aby wyłączyć</Text>
		</Tag>
	)
}

export default PreviewTag
